/**
 * Turn whatever the API returns for a date field into what the datepicker
 * expects. The API sends dates as strings ("2027-02-17"); rsuite's DatePicker
 * only understands a Date, and a string silently renders as an empty field
 * that then fails the "must be in the future" rule.
 *
 * @param   {string|Date|null|undefined} value
 * @returns {Date|null} null when there is nothing parseable
 */
const parseDateValue = (value) => {
    if (!value) return null;
    if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;

    const date = new Date(value);

    return Number.isNaN(date.getTime()) ? null : date;
};

export default parseDateValue;
